import { useState, useEffect } from "react";
import axios from "axios";
import { API } from "@/App";
import { Siren, MapPin, ArrowRight } from "lucide-react";
import { SpeakButton } from "./SpeakButton";

export function SOSBanner() {
  const [sosEmergencies, setSosEmergencies] = useState([]);

  useEffect(() => {
    const check = async () => {
      try {
        const res = await axios.get(`${API}/sos/active`);
        setSosEmergencies(res.data.sos_emergencies || []);
      } catch { setSosEmergencies([]); }
    };
    check();
    const interval = setInterval(check, 30000);
    return () => clearInterval(interval);
  }, []);

  if (sosEmergencies.length === 0) return null;

  return (
    <div className="w-full" data-testid="sos-banner">
      {sosEmergencies.map((emg) => (
        <div
          key={emg.emergency_id}
          className="relative overflow-hidden bg-red-600 text-white"
        >
          {/* Animated pulse background */}
          <div className="absolute inset-0 bg-red-500 animate-pulse opacity-30" />
          
          <div className="relative max-w-7xl mx-auto px-4 py-3 flex items-center justify-between gap-4">
            <div className="flex items-center gap-3 min-w-0">
              <div className="w-10 h-10 rounded-full bg-white/20 flex items-center justify-center shrink-0 animate-bounce">
                <Siren className="w-5 h-5 text-white" />
              </div>
              <div className="min-w-0">
                <p className="font-heading text-sm font-bold tracking-wide uppercase">
                  SOS Emergencia Activa
                </p>
                <p className="font-body text-sm text-white/90 truncate">
                  {emg.title} {emg.location_name && `— ${emg.location_name}`}
                </p>
              </div>
            </div>
            <div className="flex items-center gap-2 shrink-0">
              <SpeakButton
                text={`Alerta de emergencia SOS. ${emg.title}. ${emg.description}. Ubicación: ${emg.location_name || 'no especificada'}. Se necesita ayuda urgente.`}
                label="Escuchar"
                className="!text-white hover:!bg-white/20"
              />
              <a
                href={`/needs?emergency=${emg.emergency_id}`}
                className="flex items-center gap-1.5 bg-white text-red-600 font-heading text-xs font-bold px-4 py-2 rounded-full hover:bg-white/90 transition-colors"
                data-testid={`sos-help-btn-${emg.emergency_id}`}
              >
                Ayudar ahora
                <ArrowRight className="w-3.5 h-3.5" />
              </a>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
